import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SubmissionResponse } from '../model/submission-response';

@Injectable({
  providedIn: 'root'
})
export class SubmissionService {
  private readonly submitWithoutPaymentUrl = '/api/submitWithoutPayment';
  private readonly submitWithPaymentUrl = '/api/submitWithPayment';

  constructor(private http: HttpClient) {
  }

  submitWithoutPayment(billeeId: number, payPlan: string) {
    return this.http.post<SubmissionResponse>(
        this.submitWithoutPaymentUrl, { billeeId, payPlan }
    );
  }

  submitWithPayment(
      amount: number,
      billeeId: number,
      email: string,
      fee: number,
      payPlan: string,
      paymentDate: string,
      paymentToken: string,
      savePaymentDetails: boolean
  ) {
    return this.http.post<SubmissionResponse>(
        this.submitWithPaymentUrl,
        {
          amount,
          billeeId,
          email,
          fee,
          payPlan,
          paymentDate,
          paymentToken,
          savePaymentDetails
        }
    );
  }
}
